@if (currentUser()) {
  @if (displayMode === 'OVERLAY') {
    <ng-container *ngTemplateOutlet="openerTemplate" />
  } @else {
    <ftr-dropdown-menu [menuItems]="menuItems" data-track-group="Public Side Nav User Dropdown">
      <ng-container *ngTemplateOutlet="openerTemplate" />
    </ftr-dropdown-menu>
  }
}

<ng-template #openerTemplate>
  <button
    class="user-and-org-dropdown"
    aria-label="Open user menu"
    (click)="displayMode === 'OVERLAY' ? dropdownOpened.emit() : toggle()"
    (keydown.enter)="displayMode === 'OVERLAY' ? dropdownOpened.emit() : toggle()"
  >
    @if (collapsed) {
      <ftr-user-avatar [user]="currentUser()" size="Small" />
    } @else {
      <div class="user-and-org-dropdown__user">
        <ftr-user-avatar [user]="currentUser()" size="Small" />
        <div class="user-and-org-dropdown__name">{{ currentUser()!.givenName }} {{ currentUser()!.familyName }}</div>
      </div>
      <svg [ftrIcon]="displayMode === 'OVERLAY' ? 'ChevronRight' : 'ChevronDown'" [iconSize]="18" />
    }
  </button>
</ng-template>
